const colors = {
    accent: {
        900: '#095A7D',
        800: '#1C8BA9',
        700: '#0DB2DF',
        600: '#51CAEB',
        500: '#61DAFB',
        400: '#9BE5F9',
        300: '#C4F2FE',
        200: '#DDF8FF',
        100: '#E8FAFF'
    },
    main: {
        900: '#0A0F18',
        800: '#1B2029',
        700: '#282C34',
        600: '#333E4E',
        500: '#485E73',
        400: '#6D8CAA',
        300: '#8BA3B8',
        200: '#A3BDD4',
        100: '#BECEEE'
    },
    variants: {
        500: '#4D9BE3'
    }
    // main_light: '#374050',
    // main_light_sm: '#425169',
    // main_lighter: '#3a4558',
    // main_lightest: '#93a0b7'
}

export default colors
